import { lazy, Suspense } from 'react';
import { createBrowserRouter, type RouteObject } from 'react-router-dom';
import { FullscreenSpinner } from '../components/FullscreenSpinner';
import { RequireAuth } from './guards';
import { DashboardPage } from '../pages/DashboardPage';
import { LandingPage } from '../pages/LandingPage';
import { LoginPage } from '../pages/LoginPage';
import { NotFoundPage } from '../pages/NotFoundPage';
import { RegisterPage } from '../pages/RegisterPage';
import { RouteError } from '../pages/RouteError';
import { SettingsPage } from '../pages/SettingsPage';
import { VerifyLinkPage } from '../pages/VerifyLinkPage';

// The board bundles the canvas engine; load it only when a board is opened.
const BoardPage = lazy(() => import('../pages/BoardPage').then((m) => ({ default: m.BoardPage })));

const pages: RouteObject[] = [
  { path: '/', element: <LandingPage /> },
  { path: '/login', element: <LoginPage /> },
  { path: '/register', element: <RegisterPage /> },
  { path: '/auth/verify', element: <VerifyLinkPage /> },
  {
    path: '/boards',
    element: (
      <RequireAuth>
        <DashboardPage />
      </RequireAuth>
    ),
  },
  {
    path: '/settings',
    element: (
      <RequireAuth>
        <SettingsPage />
      </RequireAuth>
    ),
  },
  {
    path: '/b/:id',
    element: (
      <Suspense fallback={<FullscreenSpinner />}>
        <BoardPage />
      </Suspense>
    ),
  },
  { path: '*', element: <NotFoundPage /> },
];

export const routes: RouteObject[] = [{ errorElement: <RouteError />, children: pages }];

export const createRouter = () => createBrowserRouter(routes);
